import { render, staticRenderFns } from "./crudSellers.vue?vue&type=template&id=41b0bdf6&"
import script from "./crudSellers.vue?vue&type=script&lang=js&"
export * from "./crudSellers.vue?vue&type=script&lang=js&"
import style0 from "./crudSellers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports